import { InfoBlock } from '@hg/stylizator/components'
import * as React from 'react'

interface IAttributes {
  illustration: React.ReactElement
  illustrationAlt?: string
  text: string
}

const InfoBlockComponent: React.FC<IAttributes> = (props) => (
  <InfoBlock icon={props.illustration}>{props.text}</InfoBlock>
)

export default InfoBlockComponent
